import { EyeCrossedIcon, EyeIcon, StyledButton } from "@aureskonnect/react-ui";
import { isCatalogueDisplayMode } from "@constants";
import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import Modal from "react-modal";

import { getAlertActionButtonImageSrc } from "@helpers/general";

import {
    kioskStore,
    setIsScanQrCodeModalOpened,
    setQrCodeValue,
} from "@pages/Kiosk/store";

export function ScanQrCodeModalWrapper(): JSX.Element {
    const {
        isScanQrCodeModalOpened,
        qrCodeValue,
        project: {
            template: {
                content: { actionsButtons },
            },
        },
    } = useSnapshot(kioskStore);
    const [isQrCodeShown, setIsQrCodeShown] = React.useState(false);

    const alertImgSrc = getAlertActionButtonImageSrc(
        actionsButtons as ActionsButtonsDesignType
    );

    function handleOnChangeEvent(e: React.ChangeEvent<HTMLInputElement>) {
        setQrCodeValue(e.target.value);
    }

    return (
        <Modal
            isOpen={isScanQrCodeModalOpened}
            ariaHideApp={false}
            style={{
                overlay: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "1368px",
                    width: "914px",
                    marginTop: "275px",
                    marginLeft: "84px",
                    backgroundColor: "rgba(81, 79, 79, 0.55)",
                    zIndex: 2,
                },
                content: {
                    display: "flex",
                    flexDirection: "column",
                    padding: "0px",
                    color: "black",
                    height: "620px",
                    width: "606px",
                    zIndex: 2,
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #c2bebe",
                    bottom: "unset",
                    top: "unset",
                    right: "unset",
                    left: "unset",
                    marginTop: "135px",
                    zoom: `${isCatalogueDisplayMode() ? "50%" : "100%"}`,
                },
            }}
        >
            <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{
                    gap: "50px",
                }}
            >
                <img
                    src={alertImgSrc}
                    style={{
                        height: "124px",
                        width: "144px",
                        marginTop: "30px",
                    }}
                />
                <div
                    style={{
                        textAlign: "left",
                        font: "normal normal bold 35px/55px Segoe UI",
                    }}
                >
                    {t("Unknown user !")}
                </div>
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        border: "1px solid #00000029",
                        borderRadius: "10px",
                    }}
                >
                    <input
                        className="form-input text-center qr-code__clz"
                        type={isQrCodeShown ? "text" : "password"}
                        value={qrCodeValue}
                        placeholder={t("QR CODE")}
                        onChange={handleOnChangeEvent}
                    />
                    {isQrCodeShown === false ? (
                        <EyeIcon
                            className="m-3"
                            height={30}
                            width={30}
                            onClick={() => {
                                setIsQrCodeShown(!isQrCodeShown);
                            }}
                        />
                    ) : (
                        <EyeCrossedIcon
                            className="m-3"
                            height={30}
                            width={30}
                            onClick={() => {
                                setIsQrCodeShown(!isQrCodeShown);
                            }}
                        />
                    )}
                </div>
                <StyledButton
                    rounded={true}
                    className="m-2"
                    style={{
                        width: "179px",
                        height: "61px",
                        background: "#FFFFFF 0% 0% no-repeat padding-box",
                        boxShadow: "0px 3px 6px #00000029",
                        border: "1px solid #C9C9C9",
                        borderRadius: "12px",
                        color: "black",
                    }}
                    onClick={() => {
                        setIsScanQrCodeModalOpened(false);
                        setQrCodeValue("");
                    }}
                >
                    {t("Back")}
                </StyledButton>
            </div>
        </Modal>
    );
}
